import { useCallback } from "react";
import { useSelector } from "react-redux";
import { Claim } from "src/constants";
import { RootState } from "src/store";

export type ClaimArg = Claim | Claim[] | undefined;

export function useCheckAccess() {
  const user = useSelector((state: RootState) => state.auth.user);

  function checkAccess(claims: ClaimArg) {
    if (!claims) return true;

    if (Array.isArray(claims))
      return claims.every(
        (claim) => user?.permission?.includes(claim) ?? false,
      );

    return user?.permission?.includes(claims);
  }

  return useCallback(checkAccess, [user?.permission]);
}

export function withRBAC<P extends object>(
  Component: React.ComponentType<P>,
  claims: ClaimArg,
) {
  return function (props: P) {
    const check = useCheckAccess();

    if (!check(claims)) {
      return null;
    }

    return <Component {...props} />;
  };
}
